import { render, staticRenderFns } from "./MilestoneStakeholders.vue?vue&type=template&id=32f3c566&"
import script from "./MilestoneStakeholders.vue?vue&type=script&lang=js&"
export * from "./MilestoneStakeholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports